export const WHICH_ONE_TEXT = `Whether you're looking for a great deal on a standalone cruise or an all-inclusive Enrichment Journeys®
voyage with airfare, hotels, meals, tours and so much more, Online Vacation Center has a vacation option that will meet your individual needs.
Choose what suits you best, based on your desired destination, pace and inclusions.`;
